<script>
import moment from 'moment';

export default {
  props: {
    SimpleDataType: { type: String, default: '', },
    StandardName: { type: String, default: '', },
    Title: { type: String, default: '', },
    SpanishTitle: { type: String, default: '', },
    Definition: { type: String, default: '', },
    SpanishDefinition: { type: String, default: '', },
    Synonym: { type: String, default: '', },
    SpanishSynonym: { type: String, default: '', },
    LabelClass: { type: String, default: '', },
    Required: { type: Boolean, default: false, },
    Disabled: { type: Boolean, default: false, },
    Hidden: { type: Boolean, default: false, },
    Decimal: { type: Boolean, default: false, },
    Options: { type: Array, default: () => ([]), },
    PropertyTypes: { type: Array, default: () => ([]), },
    Min: { type: String, default: '', },
    Max: { type: String, default: '', },
    Default: { type: String, default: '', },
    Size: { type: String, default: 'md', },
    field: { type: Object, default: () => ({}), },
    value: { default: '', },
    Color: { type: String, default: 'success', },
    lang: { type: String, default: 'en', },
    placeholder: { type: String, default: '', },
    trueValue: { type: [String, Boolean], default: true, },
    falseValue: { type: [String, Boolean], default: false, },
  },
  components: { },
  data() {
    let $this = this;
    let randomid = 'id'+(Math.random() + 1).toString(36).substring(7);
    return {
      randomid: randomid,
      formattedOptions: [],
      formattedValue: '',

      // String List, Single
      // String List, Multi
      // Textarea
      // Money
      // Number
      // Boolean
      // Date
      // Date and time
    }
  },
  computed: {
    compTitle: function() {
      if(this.lang == 'sp' && this.SpanishTitle) { return this.SpanishTitle; }
      return this.Title;
    },
    compDefinition: function() {
      if(this.lang == 'sp' && this.SpanishDefinition) { return this.SpanishDefinition; }
      return this.Definition;
    },
    compSynonym: function() {
      if(this.lang == 'sp' && this.SpanishSynonym) { return this.SpanishSynonym; }
      return this.Synonym;
    },
    compSizeFormControl: function() {
      if(this.Size.toLowerCase() == 'sm') { return 'form-control-sm'; }
      if(this.Size.toLowerCase() == 'lg') { return 'form-control-lg'; }
      return '';
    },
    compSize: function() {
      if(this.Size.toLowerCase() == 'sm') { return 'sm'; }
      if(this.Size.toLowerCase() == 'lg') { return 'lg'; }
      return '';
    },
    compSizePretty: function() {
      if(this.Size.toLowerCase() == 'sm') { return 'p-smaller'; }
      if(this.Size.toLowerCase() == 'lg') { return 'p-bigger'; }
      return '';
    },
  },
  watch: {
    Options: {
      immediate: true,
      handler (newValue, oldValue) {
        var returnvalue = [];
        if(Array.isArray(this.Options) && this.Options.length > 0) { for(var i in this.Options) {
          if(Object.hasOwn(this.Options[i], 'name') && Object.hasOwn(this.Options[i], 'value')) {
            returnvalue.push(this.Options[i]);
          } else if(typeof this.Options[i] === 'string' || this.Options[i] instanceof String) {
            returnvalue.push({name: this.Options[i], value: this.Options[i]});
          }
        } }
        this.formattedOptions = returnvalue;
      }
    },
    value: {
      immediate: true,
      handler (newValue, oldValue) {
        if(newValue == null) { newValue = ''; }
        if(this.SimpleDataType == 'String List, Single' || this.SimpleDataType == 'String List, Multi') {
          var returnvalue = [];
          if(Array.isArray(newValue) && newValue.length > 0) {
            for(var i in newValue) {
              if(Array.isArray(this.formattedOptions) && this.formattedOptions.length > 0) {
                var found = false;
                for(var j in this.formattedOptions) {
                  if(newValue[i] == this.formattedOptions[j].value) { returnvalue.push(this.formattedOptions[j]); found = true; break; }
                }
                if(!found) { returnvalue.push({name: newValue[i], value: newValue[i]}); }
              } else {
                returnvalue.push({name: newValue[i], value: newValue[i]});
              }
            }
          } else if((newValue || newValue === 0) && !Array.isArray(newValue)) {
            if(Array.isArray(this.formattedOptions) && this.formattedOptions.length > 0) {
              var found = false;
              for(var j in this.formattedOptions) {
                if(newValue == this.formattedOptions[j].value) { returnvalue.push(this.formattedOptions[j]); found = true; break; }
              }
              if(!found) { returnvalue.push({name: newValue, value: newValue}); }
            }
          }
          this.formattedValue = returnvalue;
        } else if(this.SimpleDataType == 'Date' && newValue) {
          this.formattedValue = moment(newValue).format('YYYY-MM-DD');
        } else {
          this.formattedValue = newValue;
        }
      }
    }
  },
  mounted() {
    if(this.SimpleDataType == 'String List, Multi' || this.SimpleDataType == 'String List, Single') {
      var required = this.Required && (this.formattedValue == null || (Array.isArray(this.formattedValue) && this.formattedValue.length == 0));
      this.$refs[this.randomid].$el.querySelector('input').required = required;
    }
  },
  created() {

  },
  methods: {
    updateMulti(value) {
      var required = this.Required && (value == null || (Array.isArray(value) && value.length == 0));
      this.$refs[this.randomid].$el.querySelector('input').required = required;
      if(this.SimpleDataType == 'String List, Multi') {
        var returnvalue = [];
        if(Array.isArray(value) && value.length > 0) { for(var i in value) { returnvalue.push(value[i].value); } }
      } else {
        var returnvalue = "";
        if(value && value.value) { returnvalue = value.value; }
      }
      this.formattedValue = value;
      this.$emit('input', returnvalue);
    },
    updateGeneral() {
      // console.log(this.formattedValue);
      this.$emit('input', this.formattedValue);
    },
  }
}
</script>


<template>

  <div class="form-group">
    <label :for="randomid" v-if="compTitle && SimpleDataType != 'Boolean'" :class="LabelClass" v-tippy @show="() => compDefinition || (compSynonym && compSynonym.length) ? true : false" :content="
      `<div class='text-left'>`+
      (compDefinition ? `<strong>Definition</strong><br>`+compDefinition : '')+
      (compDefinition && compSynonym && compSynonym.length ? `<br><br>` : ``)+
      (compSynonym && compSynonym.length ? `<strong>Synonym(s)</strong><br>`+compSynonym.join(', ') : '')+
      `</div>`
      "><span v-if="Required" class="text-danger" v-tippy content="Required">* </span>{{compTitle}} 
      <Icon  v-if="compDefinition || (compSynonym && compSynonym.length)" icon="ri:information-fill" class="text-muted" />
    </label>



    <div v-if="SimpleDataType == 'String List, Single'">
      <!-- <select :id="randomid" class="form-control" :class="compSizeFormControl" v-model="formattedValue" :required="Required" :disabled="Disabled" @change="updateGeneral" :placeholder="placeholder">
        <option value="" disabled selected>{{placeholder}}</option>
        <option v-for="(option, option_i) in formattedOptions" :key="option_i" :value="option.value">{{option.name}}</option>
      </select> -->

      <multiselect :id="randomid" :ref="randomid" :class="compSize" v-model="formattedValue" track-by="value" label="name" @input="updateMulti" :options="formattedOptions" :required="Required" :disabled="Disabled" :taggable="false" :multiple="false" :close-on-select="true" :clear-on-select="false" :preserve-search="true" :placeholder="placeholder">
      </multiselect>
    </div>

    <div v-else-if="SimpleDataType == 'String List, Multi'">
      <multiselect :id="randomid" :ref="randomid" :class="compSize" v-model="formattedValue" track-by="value" label="name" @input="updateMulti" :options="formattedOptions" :required="Required" :disabled="Disabled" :taggable="false" :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true" :placeholder="placeholder">
      </multiselect>
    </div>

    <div v-else-if="SimpleDataType == 'Textarea'">
      <b-form-textarea :id="randomid" :size="compSize" rows="1" max-rows="15" :maxlength="Max" v-model="formattedValue" :required="Required" :disabled="Disabled" @change="updateGeneral" :placeholder="placeholder"></b-form-textarea>
      <div v-if="Max" class="small text-muted">Character limit : {{formattedValue.length}} / {{Max}}</div>
    </div>

    <div v-else-if="SimpleDataType == 'Money'">
      <w-money :id="randomid" class="form-control" :class="compSizeFormControl" v-model="formattedValue" :required="Required" :disabled="Disabled" :decimal="Decimal" @input="updateGeneral" :placeholder="placeholder"></w-money>
    </div>

    <div v-else-if="SimpleDataType == 'Number'">
      <input :id="randomid" type="number" class="form-control" :class="compSizeFormControl" :min="Min" :max="Max" step="any" v-model="formattedValue" :required="Required" :disabled="Disabled" @change="updateGeneral" :placeholder="placeholder">
    </div>

    <div v-else-if="SimpleDataType == 'Phone'">
      <the-mask :id="randomid" type="tel" class="form-control" :class="compSizeFormControl" :mask="['(###) ###-####']" v-model="formattedValue" :required="Required" :disabled="Disabled" @input="updateGeneral" :placeholder="placeholder" />
    </div>


    <div v-else-if="SimpleDataType == 'Boolean'">
      <p-check :id="randomid" class="p-default p-curve p-smooth" :class="compSizePretty + (compTitle ? '' : ' m-0')" :color="Color+'-o'" v-model="formattedValue" :true-value="trueValue" :false-value="falseValue" :required="Required" :disabled="Disabled" @change="updateGeneral" v-tippy @show="() => compDefinition || (compSynonym && compSynonym.length) ? true : false" :content="
        `<div class='text-left'>`+
        (compDefinition ? `<strong>Definition</strong><br>`+compDefinition : '')+
        (compDefinition && compSynonym && compSynonym.length ? `<br><br>` : ``)+
        (compSynonym && compSynonym.length ? `<strong>Synonym(s)</strong><br>`+compSynonym.join(', ') : '')+
        `</div>`
        "> <span v-if="Required" class="text-danger" v-tippy content="Required">* </span> {{compTitle}} <i v-if="compDefinition || (compSynonym && compSynonym.length)" class="mdi mdi-information-outline text-muted"></i>
      </p-check>
    </div>

    <div v-else-if="SimpleDataType == 'Date'">
      <input :id="randomid" type="date" class="form-control" :class="compSizeFormControl" v-model="formattedValue" :required="Required" :disabled="Disabled" @change="updateGeneral" :placeholder="placeholder">
    </div>

    <div v-else-if="SimpleDataType == 'Time'">
      <input :id="randomid" type="time" class="form-control" :class="compSizeFormControl" v-model="formattedValue" :required="Required" :disabled="Disabled" @change="updateGeneral" :placeholder="placeholder">
    </div>

    <div v-else-if="SimpleDataType == 'Date and time'">
      <input :id="randomid" type="datetime-local" class="form-control" :class="compSizeFormControl" v-model="formattedValue" :required="Required" :disabled="Disabled" @change="updateGeneral" :placeholder="placeholder">
    </div>

    <div v-else-if="SimpleDataType == 'Date range'">
      <date-range-picker :id="randomid" :ref="randomid" :class="compSize" v-model="formattedValue" @update="updateGeneral" :auto-apply="true" :showDropdowns="true" singleDatePicker="range" opens="right" :required="Required" :disabled="Disabled">
        <template #input="picker">
          {{ picker.startDate || picker.endDate ? moment(picker.startDate).format("MM/DD/YYYY")+' - '+moment(picker.endDate).format("MM/DD/YYYY") : placeholder }}
          <span class="float-right ml-2 text-hover-inherit"><Icon icon="ri:calendar-event-fill" /></span>
          <a v-if="picker.startDate || picker.endDate" class="float-right ml-2 text-dark text-hover-danger" @click.stop="formattedValue.startDate = formattedValue.endDate = null" v-tippy content="Clear"><Icon icon="ri:close-circle-line" /></a>
        </template>
      </date-range-picker>
    </div>

    <div v-else-if="SimpleDataType == 'Password'">
      <input :id="randomid" type="password" class="form-control" :class="compSizeFormControl" v-model="formattedValue" :required="Required" :disabled="Disabled" @change="updateGeneral" :placeholder="placeholder">
    </div>

    <div v-else>
      <input :id="randomid" type="text" class="form-control" :class="compSizeFormControl" v-model="formattedValue" :required="Required" :disabled="Disabled" :maxlength="Max" @change="updateGeneral" :placeholder="placeholder">
      <div v-if="Max" class="small text-muted">Character limit : {{formattedValue}} / {{Max}}</div>
    </div>

    <!-- <div v-if="Disabled" class="small text-muted">Input is marked as read only</div> -->

  </div>

</template>
